module.exports = __webpack_public_path__ + "img/green-shoe.0a85ed38.png";